/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OrganisationAutomatedWorkflowsBox_OrganisationWorkflowFragment = { __typename: 'OrganisationWorkflow', id: string, workflowType: string, description: string, active: boolean, triggerEventNames: Array<string>, triggerFilter: any, config: any, createdAt: any, updatedAt: any };

export type OrganisationWorkflowsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type OrganisationWorkflowsQuery = { organisationWorkflows: Array<{ __typename: 'OrganisationWorkflow', id: string, workflowType: string, description: string, active: boolean, triggerEventNames: Array<string>, triggerFilter: any, config: any, createdAt: any, updatedAt: any }> };

export type SetOrganisationWorkflowActiveMutationVariables = Types.Exact<{
  workflowId: Types.Scalars['ID']['input'];
  active: Types.Scalars['Boolean']['input'];
}>;


export type SetOrganisationWorkflowActiveMutation = { setOrganisationWorkflowActive: { __typename: 'SetOrganisationWorkflowActiveResult', workflow: { __typename: 'OrganisationWorkflow', id: string, workflowType: string, description: string, active: boolean, triggerEventNames: Array<string>, triggerFilter: any, config: any, createdAt: any, updatedAt: any } } };

export type ModifyOrganisationWorkflowSettingsMutationVariables = Types.Exact<{
  workflowId: Types.Scalars['ID']['input'];
  input: Types.ModifyOrganisationWorkflowSettingsInput;
}>;


export type ModifyOrganisationWorkflowSettingsMutation = { modifyOrganisationWorkflowSettings: { __typename: 'ModifyOrganisationWorkflowSettingsResult', workflow: { __typename: 'OrganisationWorkflow', id: string, workflowType: string, description: string, active: boolean, triggerEventNames: Array<string>, triggerFilter: any, config: any, createdAt: any, updatedAt: any } } };

export type CreateOrganisationWorkflowMutationVariables = Types.Exact<{
  input: Types.CreateOrganisationWorkflowInput;
}>;


export type CreateOrganisationWorkflowMutation = { createOrganisationWorkflow: { __typename: 'CreateOrganisationWorkflowResult', workflow: { __typename: 'OrganisationWorkflow', id: string, workflowType: string, description: string, active: boolean, triggerEventNames: Array<string>, triggerFilter: any, config: any, createdAt: any, updatedAt: any } } };

export type DeleteOrganisationWorkflowMutationVariables = Types.Exact<{
  workflowId: Types.Scalars['ID']['input'];
}>;


export type DeleteOrganisationWorkflowMutation = { deleteOrganisationWorkflow: { __typename: 'DeleteOrganisationWorkflowResult', success: boolean } };

export type WorkflowTypeDefinitionsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type WorkflowTypeDefinitionsQuery = { workflowTypeDefinitions: Array<{ __typename: 'WorkflowTypeDefinition', workflowType: string, label: string, description: string, compatibleTriggerEvents: Array<string>, configFields: Array<{ __typename: 'WorkflowConfigFieldDefinition', key: string, label: string, fieldType: string, required: boolean }> }> };

export type AvailableTriggerEventNamesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AvailableTriggerEventNamesQuery = { availableTriggerEventNames: Array<string> };

export const OrganisationAutomatedWorkflowsBox_OrganisationWorkflowFragmentDoc = gql`
    fragment OrganisationAutomatedWorkflowsBox_OrganisationWorkflow on OrganisationWorkflow {
  id
  workflowType
  description
  active
  triggerEventNames
  triggerFilter
  config
  createdAt
  updatedAt
}
    `;
export const OrganisationWorkflowsDocument = gql`
    query OrganisationWorkflows {
  organisationWorkflows {
    ...OrganisationAutomatedWorkflowsBox_OrganisationWorkflow
  }
}
    ${OrganisationAutomatedWorkflowsBox_OrganisationWorkflowFragmentDoc}`;

/**
 * __useOrganisationWorkflowsQuery__
 *
 * To run a query within a React component, call `useOrganisationWorkflowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationWorkflowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationWorkflowsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganisationWorkflowsQuery(baseOptions?: Apollo.QueryHookOptions<OrganisationWorkflowsQuery, OrganisationWorkflowsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganisationWorkflowsQuery, OrganisationWorkflowsQueryVariables>(OrganisationWorkflowsDocument, options);
      }
export function useOrganisationWorkflowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganisationWorkflowsQuery, OrganisationWorkflowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganisationWorkflowsQuery, OrganisationWorkflowsQueryVariables>(OrganisationWorkflowsDocument, options);
        }
export function useOrganisationWorkflowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganisationWorkflowsQuery, OrganisationWorkflowsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganisationWorkflowsQuery, OrganisationWorkflowsQueryVariables>(OrganisationWorkflowsDocument, options);
        }
export type OrganisationWorkflowsQueryHookResult = ReturnType<typeof useOrganisationWorkflowsQuery>;
export type OrganisationWorkflowsLazyQueryHookResult = ReturnType<typeof useOrganisationWorkflowsLazyQuery>;
export type OrganisationWorkflowsSuspenseQueryHookResult = ReturnType<typeof useOrganisationWorkflowsSuspenseQuery>;
export type OrganisationWorkflowsQueryResult = Apollo.QueryResult<OrganisationWorkflowsQuery, OrganisationWorkflowsQueryVariables>;
export const SetOrganisationWorkflowActiveDocument = gql`
    mutation SetOrganisationWorkflowActive($workflowId: ID!, $active: Boolean!) {
  setOrganisationWorkflowActive(workflowId: $workflowId, active: $active) {
    workflow {
      ...OrganisationAutomatedWorkflowsBox_OrganisationWorkflow
    }
  }
}
    ${OrganisationAutomatedWorkflowsBox_OrganisationWorkflowFragmentDoc}`;
export type SetOrganisationWorkflowActiveMutationFn = Apollo.MutationFunction<SetOrganisationWorkflowActiveMutation, SetOrganisationWorkflowActiveMutationVariables>;

/**
 * __useSetOrganisationWorkflowActiveMutation__
 *
 * To run a mutation, you first call `useSetOrganisationWorkflowActiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetOrganisationWorkflowActiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setOrganisationWorkflowActiveMutation, { data, loading, error }] = useSetOrganisationWorkflowActiveMutation({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useSetOrganisationWorkflowActiveMutation(baseOptions?: Apollo.MutationHookOptions<SetOrganisationWorkflowActiveMutation, SetOrganisationWorkflowActiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetOrganisationWorkflowActiveMutation, SetOrganisationWorkflowActiveMutationVariables>(SetOrganisationWorkflowActiveDocument, options);
      }
export type SetOrganisationWorkflowActiveMutationHookResult = ReturnType<typeof useSetOrganisationWorkflowActiveMutation>;
export type SetOrganisationWorkflowActiveMutationResult = Apollo.MutationResult<SetOrganisationWorkflowActiveMutation>;
export type SetOrganisationWorkflowActiveMutationOptions = Apollo.BaseMutationOptions<SetOrganisationWorkflowActiveMutation, SetOrganisationWorkflowActiveMutationVariables>;
export const ModifyOrganisationWorkflowSettingsDocument = gql`
    mutation ModifyOrganisationWorkflowSettings($workflowId: ID!, $input: ModifyOrganisationWorkflowSettingsInput!) {
  modifyOrganisationWorkflowSettings(workflowId: $workflowId, input: $input) {
    workflow {
      ...OrganisationAutomatedWorkflowsBox_OrganisationWorkflow
    }
  }
}
    ${OrganisationAutomatedWorkflowsBox_OrganisationWorkflowFragmentDoc}`;
export type ModifyOrganisationWorkflowSettingsMutationFn = Apollo.MutationFunction<ModifyOrganisationWorkflowSettingsMutation, ModifyOrganisationWorkflowSettingsMutationVariables>;

/**
 * __useModifyOrganisationWorkflowSettingsMutation__
 *
 * To run a mutation, you first call `useModifyOrganisationWorkflowSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModifyOrganisationWorkflowSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modifyOrganisationWorkflowSettingsMutation, { data, loading, error }] = useModifyOrganisationWorkflowSettingsMutation({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useModifyOrganisationWorkflowSettingsMutation(baseOptions?: Apollo.MutationHookOptions<ModifyOrganisationWorkflowSettingsMutation, ModifyOrganisationWorkflowSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ModifyOrganisationWorkflowSettingsMutation, ModifyOrganisationWorkflowSettingsMutationVariables>(ModifyOrganisationWorkflowSettingsDocument, options);
      }
export type ModifyOrganisationWorkflowSettingsMutationHookResult = ReturnType<typeof useModifyOrganisationWorkflowSettingsMutation>;
export type ModifyOrganisationWorkflowSettingsMutationResult = Apollo.MutationResult<ModifyOrganisationWorkflowSettingsMutation>;
export type ModifyOrganisationWorkflowSettingsMutationOptions = Apollo.BaseMutationOptions<ModifyOrganisationWorkflowSettingsMutation, ModifyOrganisationWorkflowSettingsMutationVariables>;
export const CreateOrganisationWorkflowDocument = gql`
    mutation CreateOrganisationWorkflow($input: CreateOrganisationWorkflowInput!) {
  createOrganisationWorkflow(input: $input) {
    workflow {
      ...OrganisationAutomatedWorkflowsBox_OrganisationWorkflow
    }
  }
}
    ${OrganisationAutomatedWorkflowsBox_OrganisationWorkflowFragmentDoc}`;
export type CreateOrganisationWorkflowMutationFn = Apollo.MutationFunction<CreateOrganisationWorkflowMutation, CreateOrganisationWorkflowMutationVariables>;

/**
 * __useCreateOrganisationWorkflowMutation__
 *
 * To run a mutation, you first call `useCreateOrganisationWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganisationWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganisationWorkflowMutation, { data, loading, error }] = useCreateOrganisationWorkflowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganisationWorkflowMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganisationWorkflowMutation, CreateOrganisationWorkflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganisationWorkflowMutation, CreateOrganisationWorkflowMutationVariables>(CreateOrganisationWorkflowDocument, options);
      }
export type CreateOrganisationWorkflowMutationHookResult = ReturnType<typeof useCreateOrganisationWorkflowMutation>;
export type CreateOrganisationWorkflowMutationResult = Apollo.MutationResult<CreateOrganisationWorkflowMutation>;
export type CreateOrganisationWorkflowMutationOptions = Apollo.BaseMutationOptions<CreateOrganisationWorkflowMutation, CreateOrganisationWorkflowMutationVariables>;
export const DeleteOrganisationWorkflowDocument = gql`
    mutation DeleteOrganisationWorkflow($workflowId: ID!) {
  deleteOrganisationWorkflow(workflowId: $workflowId) {
    success
  }
}
    `;
export type DeleteOrganisationWorkflowMutationFn = Apollo.MutationFunction<DeleteOrganisationWorkflowMutation, DeleteOrganisationWorkflowMutationVariables>;

/**
 * __useDeleteOrganisationWorkflowMutation__
 *
 * To run a mutation, you first call `useDeleteOrganisationWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganisationWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganisationWorkflowMutation, { data, loading, error }] = useDeleteOrganisationWorkflowMutation({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useDeleteOrganisationWorkflowMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganisationWorkflowMutation, DeleteOrganisationWorkflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganisationWorkflowMutation, DeleteOrganisationWorkflowMutationVariables>(DeleteOrganisationWorkflowDocument, options);
      }
export type DeleteOrganisationWorkflowMutationHookResult = ReturnType<typeof useDeleteOrganisationWorkflowMutation>;
export type DeleteOrganisationWorkflowMutationResult = Apollo.MutationResult<DeleteOrganisationWorkflowMutation>;
export type DeleteOrganisationWorkflowMutationOptions = Apollo.BaseMutationOptions<DeleteOrganisationWorkflowMutation, DeleteOrganisationWorkflowMutationVariables>;
export const WorkflowTypeDefinitionsDocument = gql`
    query WorkflowTypeDefinitions {
  workflowTypeDefinitions {
    workflowType
    label
    description
    compatibleTriggerEvents
    configFields {
      key
      label
      fieldType
      required
    }
  }
}
    `;

/**
 * __useWorkflowTypeDefinitionsQuery__
 *
 * To run a query within a React component, call `useWorkflowTypeDefinitionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkflowTypeDefinitionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkflowTypeDefinitionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useWorkflowTypeDefinitionsQuery(baseOptions?: Apollo.QueryHookOptions<WorkflowTypeDefinitionsQuery, WorkflowTypeDefinitionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkflowTypeDefinitionsQuery, WorkflowTypeDefinitionsQueryVariables>(WorkflowTypeDefinitionsDocument, options);
      }
export function useWorkflowTypeDefinitionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkflowTypeDefinitionsQuery, WorkflowTypeDefinitionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkflowTypeDefinitionsQuery, WorkflowTypeDefinitionsQueryVariables>(WorkflowTypeDefinitionsDocument, options);
        }
export function useWorkflowTypeDefinitionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkflowTypeDefinitionsQuery, WorkflowTypeDefinitionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkflowTypeDefinitionsQuery, WorkflowTypeDefinitionsQueryVariables>(WorkflowTypeDefinitionsDocument, options);
        }
export type WorkflowTypeDefinitionsQueryHookResult = ReturnType<typeof useWorkflowTypeDefinitionsQuery>;
export type WorkflowTypeDefinitionsLazyQueryHookResult = ReturnType<typeof useWorkflowTypeDefinitionsLazyQuery>;
export type WorkflowTypeDefinitionsSuspenseQueryHookResult = ReturnType<typeof useWorkflowTypeDefinitionsSuspenseQuery>;
export type WorkflowTypeDefinitionsQueryResult = Apollo.QueryResult<WorkflowTypeDefinitionsQuery, WorkflowTypeDefinitionsQueryVariables>;
export const AvailableTriggerEventNamesDocument = gql`
    query AvailableTriggerEventNames {
  availableTriggerEventNames
}
    `;

/**
 * __useAvailableTriggerEventNamesQuery__
 *
 * To run a query within a React component, call `useAvailableTriggerEventNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableTriggerEventNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableTriggerEventNamesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAvailableTriggerEventNamesQuery(baseOptions?: Apollo.QueryHookOptions<AvailableTriggerEventNamesQuery, AvailableTriggerEventNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailableTriggerEventNamesQuery, AvailableTriggerEventNamesQueryVariables>(AvailableTriggerEventNamesDocument, options);
      }
export function useAvailableTriggerEventNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableTriggerEventNamesQuery, AvailableTriggerEventNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailableTriggerEventNamesQuery, AvailableTriggerEventNamesQueryVariables>(AvailableTriggerEventNamesDocument, options);
        }
export function useAvailableTriggerEventNamesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AvailableTriggerEventNamesQuery, AvailableTriggerEventNamesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AvailableTriggerEventNamesQuery, AvailableTriggerEventNamesQueryVariables>(AvailableTriggerEventNamesDocument, options);
        }
export type AvailableTriggerEventNamesQueryHookResult = ReturnType<typeof useAvailableTriggerEventNamesQuery>;
export type AvailableTriggerEventNamesLazyQueryHookResult = ReturnType<typeof useAvailableTriggerEventNamesLazyQuery>;
export type AvailableTriggerEventNamesSuspenseQueryHookResult = ReturnType<typeof useAvailableTriggerEventNamesSuspenseQuery>;
export type AvailableTriggerEventNamesQueryResult = Apollo.QueryResult<AvailableTriggerEventNamesQuery, AvailableTriggerEventNamesQueryVariables>;